/*! Copyright 2026 Fonticons, Inc. - https://webawesome.com/license */
import {
  E
} from "./chunk.BKE5EYM3.js";

// ../../node_modules/lit-html/directives/if-defined.js
var o = (o2) => o2 ?? E;

export {
  o
};
/*! Bundled license information:

lit-html/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
